import styled from 'styled-components';

export const Borderline = styled.div`
  margin-top: 2%;
  border-top: 1px solid rgba(0, 0, 0, 0.5);
  margin-bottom: 2%;
`;
